import React from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import './styles.scss'

const ProfileMenu = ({ t }) => (
  <div className="profile-menu">
    <div className="profile-menu__control profile-menu__control--left">
      <NavLink to="/profile/general" className="profile-menu__link">
        {t('General')}
      </NavLink>
    </div>
    <div className="profile-menu__control profile-menu__control--left">
      <NavLink to="/profile/notifications" className="profile-menu__link">
        {t('Notifications')}
      </NavLink>
    </div>
    <div className="profile-menu__control profile-menu__control--left">
      <NavLink to="/profile/out-of-office" className="profile-menu__link">
        {t('Out of Office')}
      </NavLink>
    </div>
    <div className="profile-menu__control profile-menu__control--left">
      <NavLink to="/profile/active-protracks" className="profile-menu__link">
        {t('Switch ProTrack')}
      </NavLink>
    </div>
  </div>
)

ProfileMenu.displayName = 'ProfileMenu'

const ProfileMenuWithRouter = withRouter(ProfileMenu)

ProfileMenuWithRouter.displayName = 'ProfileMenuWithRouter'

export default withTranslation('user')(ProfileMenuWithRouter)
